import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@ngneat/transloco';

import { IdentityFieldComponent } from './identity-field.component';

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        ReactiveFormsModule,
        TranslocoModule,
    ],
    declarations: [IdentityFieldComponent],
    exports: [IdentityFieldComponent],
})
export class IdentityFieldModule {}
